import { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./NavLogProduct.scss";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import ProductDestinationTitleContainer from "app/pages/.shared/ProductDestinationTitle/ProductDestinationTitleContainer";
import ProductNameWithCategory from "app/pages/.shared/ProductNameWithCategory/ProductNameWithCategory";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import { resolutionPropType } from "app/utils/propTypes";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import Timer from "app/pages/.shared/Timer";
import { FormattedMessage } from "react-intl";
import Badge from "app/pages/.shared/Badge";
import { sendTagOnNavlogClick, sendTagOnNavlogProductClick } from "app/utils/analytics";
import { useHistory } from "react-router-dom";

const IMG_SIZES_DESKTOP = {
	small: { width: 768, height: 416 },
	medium: { width: 768, height: 416 },
	large: { width: 502, height: 240 },
	xlarge: { width: 502, height: 240 },
};

const CLOUDINARY_OPTIONS = ["c_fill"];

const NavLogProduct = ({
	uri,
	resolution,
	photo = {},
	name,
	expiration = {},
	region,
	resort,
	country,
	category,
	categoryType,
	quotationURL,
}) => {
	const history = useHistory();

	const handleProductClick = () => {
		if (quotationURL) {
			window.location = quotationURL; // quotationURL is an absolute url
		} else {
			history.push(`/${uri}`);
		}

		sendTagOnNavlogClick({ quotationURL, productUri: uri });
		sendTagOnNavlogProductClick({
			uri,
			resolution,
			photo,
			name,
			expiration,
			region,
			resort,
			country,
			category,
			categoryType,
			quotationURL,
			lastSeenProductType: quotationURL ? "quote" : "product",
		});
	};

	const isExpired = expiration.day === 0 && expiration.hour === 0;
	const productClassName = classNames({
		"navlog-product": true,
		"navlog-product--expired": isExpired,
	});

	return (
		<div className={productClassName} onClick={handleProductClick}>
			<div className="navlog-product__picture">
				{resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL ? (
					<BackgroundProgressiveImg
						sizes={IMG_SIZES_DESKTOP}
						cloudinaryOptions={CLOUDINARY_OPTIONS}
						src={photo.url}
						alt={resort}
						thumbnail={photo.thumbnail}
					/>
				) : (
					<ProgressiveImg
						className="progressive-img"
						sizes={IMG_SIZES_DESKTOP}
						src={photo.url}
						alt={resort}
						thumbnail={photo.thumbnail}
					/>
				)}
				{quotationURL && (
					<div className="navlog-product__topbar">
						<FormattedMessage id="listing.ongoing.quote" />
					</div>
				)}
			</div>
			<div className="navlog-product__footer">
				<div className="navlog-product__timer">
					<Badge>
						{isExpired ? (
							<FormattedMessage id="product.deal.expired.label" />
						) : (
							<Timer
								hour={expiration.hour}
								day={expiration.day}
								suffix={<FormattedMessage id="timer.left.label" />}
							/>
						)}
					</Badge>
				</div>

				<ProductDestinationTitleContainer
					region={region}
					resort={resort}
					country={country}
				/>
				<ProductNameWithCategory
					categoryType={categoryType}
					category={category}
					name={name}
				/>
			</div>
		</div>
	);
};

NavLogProduct.propTypes = {
	categoryType: PropTypes.string,
	category: PropTypes.number,
	country: PropTypes.string,
	region: PropTypes.string,
	resort: PropTypes.string,
	expiration: PropTypes.shape({
		day: PropTypes.number,
		hour: PropTypes.number,
	}),
	name: PropTypes.string,
	photo: PropTypes.shape({
		thumbnail: PropTypes.string,
		url: PropTypes.string,
	}),
	uri: PropTypes.string,
	resolution: resolutionPropType,
	quotationURL: PropTypes.string,
};

export default memo(NavLogProduct);
